import React from 'react';
import CheckList from '../../../../lib/CheckList/CheckList';

interface IIntroSectionProps {
  providerName?: string;
}

const IntroSection: React.FC<React.PropsWithChildren<React.PropsWithChildren<IIntroSectionProps>>> = ({ providerName }) => {
  return (
    <div>
      <CheckList
        items={[
          {
            title: 'No Obligation',
            subTitle: `${providerName} will send you back an appointment spot (if they’re available), but it’s completely up to you whether you wish to book or not`,
          },
          {
            title: 'No Credit Card Required',
            subTitle: `It’s completely free to check availability, no credit card or payment required`,
          },
        ]}
        titleClassName="lg:text-2xl"
        subTitleClassName="lg:text-lg lg:text-white"
      />
    </div>
  );
};
export default IntroSection;
